module.exports = __webpack_public_path__ + "static/media/broker.7f7225f2.jpeg";